import { Navigate, Outlet } from "react-router-dom";
import useAuthService from "../services/auth.service";
import { useUserGroups } from "@/context/user-groups.context";
import chopLogo from "@/assets/chop_logo-2.svg";

interface RoleGuardProps {
  allowedRoles: string[];
}

const RoleGuard = ({ allowedRoles }: RoleGuardProps) => {
  const { getRolesFromToken } = useAuthService();
  const { isLoading, canAccessCurrentEnv } = useUserGroups();
  const roles = getRolesFromToken();

  // Wait for group membership to resolve before making access decisions
  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-full bg-gray-100">
        <div className="text-center">
          <img
            src={chopLogo}
            alt="Children's Hospital of Philadelphia"
            className="h-16 w-auto mx-auto mb-4"
          />
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-500 mx-auto mb-4"></div>
          <p className="text-gray-600">Verifying access...</p>
        </div>
      </div>
    );
  }

  // Admin routes: require the Admin role explicitly
  const requiresAdminRole = allowedRoles.includes("Admin");
  if (requiresAdminRole) {
    if (!roles || !roles.includes("Admin")) {
      return <Navigate to="/unauthorized" replace />;
    }
  }

  if (!canAccessCurrentEnv) {
    return <Navigate to="/unauthorized" replace />;
  }

  return <Outlet />;
};

export default RoleGuard;
